import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UnsavedChangesState {
  hasUnsavedChanges: boolean;
  currentPage: string | null;
  isBlocking: boolean;
}

const initialState: UnsavedChangesState = {
  hasUnsavedChanges: false,
  currentPage: null,
  isBlocking: false,
};

const unsavedChangesSlice = createSlice({
  name: 'unsavedChanges',
  initialState,
  reducers: {
    setHasUnsavedChanges: (state, action: PayloadAction<boolean>) => {
      state.hasUnsavedChanges = action.payload;
    },
    setCurrentPage: (state, action: PayloadAction<string | null>) => {
      state.currentPage = action.payload;
    },
    setIsBlocking: (state, action: PayloadAction<boolean>) => {
      state.isBlocking = action.payload;
    },
    resetUnsavedChanges: (state) => {
      state.hasUnsavedChanges = false;
      state.currentPage = null;
      state.isBlocking = false;
    },
  },
});

export const { setHasUnsavedChanges, setCurrentPage, setIsBlocking, resetUnsavedChanges } =
  unsavedChangesSlice.actions;

export default unsavedChangesSlice.reducer;
